import { Box, FieldSet, FormField } from "@wix/design-system";
import React from "react";
import { InputWithSlider } from "./../input-with-slider/input-with-slider.js";
const NumberInputWithLabel = ({ label, infoContent, dataHook, suffix, onChange, min, max, value, logBi, zIndex }) => {
  const handleInput = (numberValue) => {
    const valueWithinBounds = isNaN(numberValue) || numberValue < min ? min : numberValue > max ? max : numberValue;
    logBi?.({ dataHook, value: valueWithinBounds });
    return onChange(valueWithinBounds);
  };
  const columnWidth = React.useMemo(() => {
    return max > 999 ? "auto 78px" : "auto 72px";
  }, [max]);
  return /* @__PURE__ */ React.createElement(Box, { direction: "vertical" }, /* @__PURE__ */ React.createElement(FormField, { inputWidth: "100%" }, /* @__PURE__ */ React.createElement(
    FieldSet,
    {
      columns: columnWidth,
      alignment: "center",
      legendPlacement: "left",
      legend: label,
      infoContent
    },
    /* @__PURE__ */ React.createElement("div", null),
    /* @__PURE__ */ React.createElement(
      InputWithSlider,
      {
        value,
        onChange: handleInput,
        zIndex,
        suffix,
        min,
        max,
        dataHook
      }
    )
  )));
};
export {
  NumberInputWithLabel
};
//# sourceMappingURL=number-input-with-label.js.map
